<div class="row main stepitem hole">
  <div class="row view-matter">
    <div class="col-12">
      <div class="row">
        <!-- client code  -->
        <div class="col-6 matterView">
          <div class="case_title">
            <button type="button" class="matter-back" (click)="goBack()" title="Back to matters" aria-label="Back to matters">
              <i class="fa fa-angle-left" aria-hidden="true"></i>
            </button>
            Matter Details - {{data?.title}}
          </div>
          
          <ul class="nav nav-pills mb-3 btnaction float-left " id="pills-tab" role="tablist">
            <li class="nav-item">
              <button id="High" name="priority" class="selectprior optionhigh" [ngClass]="{'active':featureName=='Timeline'}" id="pills-home-tab"
                data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home"
                aria-selected="true" (click)="onFeatureClick('Timeline')">Timeline</button>
            </li>
            <li class="nav-item">
              <button id="Medium" name="priority" class="selectprior optionaling" [ngClass]="{'active':featureName=='Document'}" id="pills-profile-tab"
                data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab"
                aria-controls="pills-profile" aria-selected="false"
                (click)="onFeatureClick('Document');onClick('Document')">Document(s)</button>
            </li>
            <!-- <li class="nav-item" *ngIf="product != 'corporate' && data?.type == 'internal' && catsolo !== 'solo'">
              <button id="Low" name="priority" class=" selectprior optionlow" id="pills-contact-tab"
                data-bs-toggle="pill" data-bs-target="#pills-contact" type="button" role="tab"
                aria-controls="pills-contact" aria-selected="false" (click)="onFeatureClick('T&C')">Team Member(s) and
                Client(s)</button>
            </li> -->

               <li class="nav-item" *ngIf="catsolo !== 'solo'">
                <button id="High" name="priority" class="selectprior optionling" id="pills-home-tab" [ngClass]="{'active':selectedVal=='TM'}"
                  data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home"
                  aria-selected="true" (click)="onClick('TM');onFeatureClick('T&C');">Team Member(s)</button>
              </li>
    
              <li class="nav-item" *ngIf="product != 'corporate'">
                <button id="Medium" name="priority" class="selectprior optionaling" id="pills-profile-tab" [ngClass]="{'active':selectedVal=='Clients'}"
                  data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab"
                  aria-controls="pills-profile" aria-selected="false" (click)="onClick('Clients');onFeatureClick('T&C');">Client(s)</button>
              </li>
              <li class="nav-item" *ngIf="product == 'corporate'">
                <button id="Medium" name="priority" class="selectprior optionaling cbtn" id="pills-profile-tab" [ngClass]="{'active':selectedVal=='Clients'}"
                  data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab"
                  aria-controls="pills-profile" aria-selected="false" (click)="onClick('Clients');onFeatureClick('T&C');">External Counsel(s)</button>
              </li>
              <li class="nav-item">
                <button id="Medium" name="priority" class="selectprior optionaling cbtn" id="pills-ts-tab"
                  [ngClass]="{'active':featureName=='Timesheets'}" data-bs-toggle="pill" data-bs-target="#pills-ts" type="button"
                  role="tab" aria-controls="pills-ts" aria-selected="false"
                  (click)="onFeatureClick('Timesheets');">Timesheets</button>
              </li>

            <!-- <li class="nav-item" *ngIf="product != 'corporate' && catsolo === 'solo'">
                <button id="Medium" name="priority" class="selectprior optionaling" id="pills-profile-tab" [ngClass]="{'active':selectedVal=='Clients'}"
                  data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab"
                  aria-controls="pills-profile" aria-selected="false" (click)="onClick('Clients');onFeatureClick('T&C');">Client(s)</button>
            </li>
            <li class="nav-item" *ngIf="product == 'corporate' && data?.type == 'internal'">
              <button id="Low" name="priority" class=" selectprior optionlow" id="pills-contact-tab"
                data-bs-toggle="pill" data-bs-target="#pills-contact" type="button" role="tab"
                aria-controls="pills-contact" aria-selected="false" (click)="onFeatureClick('T&C')">Team Member(s) and
                External Counsel(s)</button>
            </li> -->
          </ul>
        </div>
        <div class="col-6" *ngIf="featureName == 'Document'">
          <!-- <div class="form-group float-right">
            <div class="input-group court" id="search">
              <input type="text" class="form-control textbox" placeholder="Search" [(ngModel)]="searchText" (keyup)="keyup('doc')" />
              <img src="assets/img/search.svg" class="calimg calitem input-group-append searchimg">
            </div>
          </div> -->
                       
          <!--Search box-->
            <div class="page-header" *ngIf="showUpload">
              <div class="header-content">
                <div class="header-actions">
                  <div class="search-wrapper">
                    <input type="text" class="search-input" placeholder="Search Document" [(ngModel)]="searchDocument"
                     (ngModelChange)="onSearchChange($event)" (keydown)="preventLeadingSpace($event)">
                    <img src="assets/img/search.svg" class="search-icon">
                  </div>
            
                  <button class="btn-create" (click)="onFeatureAddNewDoc('Document');isNewDocument= !isNewDocument;AddExistingSelected = false;UploadDocSelected=true;showUpload=false;"> 
                    <i class="fa fa-plus me-2"></i> Upload New</button>
                </div>
              </div>
            </div>
          <!-- <div class="form-group name-set float-right ns2">
            <div class="input-group group-custom-align court padded" id="search">
              <input type="text" class="form-control textbox" placeholder="Search Document" [(ngModel)]="searchDocument"
                (ngModelChange)="onSearchChange($event)" (keydown)="preventLeadingSpace($event)">
              <img src="assets/img/search.svg" class="calimg calitem input-group-append searchimg2">
            </div>

              <div class="padded2" *ngIf="showUpload">
              <button class="cmatter" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="false"
              (click)="onFeatureAddNewDoc('Document');isNewDocument= !isNewDocument;AddExistingSelected = false;UploadDocSelected=true;showUpload=false;"> + Upload New</button>
              </div>
              <div class="padded2" *ngIf="!showUpload">
                <button class="dummc"></button>
              </div>
          </div> -->

        </div>

      </div>

    </div>
  </div>
    
  <div [ngClass]="(featureName == 'Timesheets' || featureName == 'Tasks') ? 'col-12' : 'col-xs-12 col-sm-12 col-md-6'"
     class="ctm" *ngIf="featureName != 'Document'">
    <div class="row" *ngIf="featureName == 'T&C'">
      <!-- client code  -->
      <div class="col-6">
        <ul class="nav nav-pills mb-3 btnaction float-left " id="pills-tab" role="tablist">
          <!-- <li class="nav-item" *ngIf="catsolo !== 'solo'">
            <button id="High" name="priority" class="selectprior optionhigh active" id="pills-home-tab" [ngClass]="{'active':selectedVal=='TM'}"
              data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home"
              aria-selected="true" (click)="onClick('TM');onFeatureClick('T&C');">Team Member(s)</button>
          </li>

          <li class="nav-item" *ngIf="product != 'corporate'">
            <button id="Medium" name="priority" class="selectprior optionaling" id="pills-profile-tab" [ngClass]="{'active':selectedVal=='Clients'}"
              data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab"
              aria-controls="pills-profile" aria-selected="false" (click)="onClick('Clients');onFeatureClick('T&C');">Client(s)</button>
          </li>
          <li class="nav-item" *ngIf="product == 'corporate'">
            <button id="Medium" name="priority" class="selectprior optionaling" id="pills-profile-tab" [ngClass]="{'active':selectedVal=='Clients'}"
              data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab"
              aria-controls="pills-profile" aria-selected="false" (click)="onClick('Clients');onFeatureClick('T&C');">External Counsel(s)</button>
          </li> -->
        </ul>
        <!-- <ul>
          <li class="nav-item">
            <button id="Medium" name="priority" class="selectprior optionaling active" id="pills-profile-tab"
              data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab"
              aria-controls="pills-profile" aria-selected="true">
              <span *ngIf="selectedVal=='TM'">Add Team Member</span>
              <span *ngIf="selectedVal=='Clients' && product != 'corporate'">Add Client</span>
              <span *ngIf="selectedVal=='Clients' && product == 'corporate'">Add External Counsel</span>
            </button>
          </li>
        </ul> -->
      </div>
       <div *ngIf="selectedVal == 'TM'">
          <p class="thheadname">Name</p>
          <img src="assets/img/SORT.PNG" class="sortico" (click)="sortMembers()">
         
          <div class="input-group court ownD" id="court">
              <p class="form-control textbox msgitemcls">
                <img src="assets/img/tree.svg" class="notfiy_tree">
                <label class="notify_mdg">{{ matterOwner }}</label>
              </p>
          </div>


          <div *ngFor="let member of selectedMembers;let i=index;">
            <div class="form-group msgicofile">
              <div class="input-group court" id="court">
                <p class="form-control textbox msgitemcls">
                 <label class="notify_mdg"> {{member?.name}}</label>
                 <span style="float: right;">
                  <!-- <img src="assets/img/mailnotif.svg" class="msgnotify1 mailicocls" (click)="onMailClick()"> &nbsp; -->
                  <img src="assets/img/msgico.svg" class="msgnotify1 msgicocls" *ngIf="member.id !== loggedUserId" (click)="onMessageClickTM(member)"> &nbsp;
                  <img src="assets/img/delete.svg" *ngIf="member.id !== loggedUserId" (click)="removeTeammember(member)" class="msgnotify1 delicocls">
                </span>
                </p>
              </div>
            </div>
          </div>
          <div class="dashedborder">
            <div class="row" style="margin-top: 15px;">
              <h6 class="col-6 assign">Assign Team Member(s)</h6>
              <!-- <div class="col-6 selOn">
                <label class="callselect">Select All</label>&nbsp;
                <input type="checkbox" value="" id="selectAllMembers" [(ngModel)]="selectAllMembersChecked" (change)="selectAllMembers($event)">
              </div> -->
            </div>
            <!-- <div class="col-4">
              <div class="form-group" id="selectbx">
                <div class="input-group court" id="search">
                  <div class="multicheck form-control textbox">
                    <label class="callselect">Select All</label>
                    <input class="form-check-inpu calimg calitem input-group-append checkboxitem" type="checkbox" value=""
                      id="selectAllMembers" (change)="selectAllMembers($event)">
                  </div>
                </div>
              </div>
            </div> -->
            <div class="form-group">
              <div class="input-group group-custom-align court" id="search">
                <input type="text" class="form-control textbox" placeholder="Search Team Member"
                  [(ngModel)]="searchTextMembers" (keyup)="keyup('tm')" />
                <img src="assets/img/search.svg" class="calimg calitemo input-group-append searchimg">
              </div>
            </div>
            <div class="form-group" id="selectbx">
              <div class="input-group group-custom-align court" id="search"
                *ngFor="let teammember of teammembersList |filter:searchTextMembers">
                <div class="multicheck form-control textbox">
                  <div class="callselect" [innerHtml]="teammember.name"></div>
                  <input class="form-check-inpu calimg calitem input-group-app end checkboxitem" #inputE1 type="checkbox" id="flexCheckDefault"
                    (change)="selectTeammember(teammember)">
                </div>
              </div>
            </div>
            <div class="btnbox">
              <button type="reset" class="btn btn-default btncancel btnrightitem" (click)="cancelItems()">Cancel</button>
              <button type="submit" class="btn btn-primary btnsave savecls" (click)="saveItems('members')"
                [disabled]="isSaveEnableTM || isSavingItems">Save</button>
            </div>
          </div>
        </div>

      <div *ngIf="selectedVal == 'Clients'">
        <p class="thheadname">Added Client(s)</p>
        <img src="assets/img/SORT.PNG" class="sortico" (click)="sortClients()">
        <div *ngFor="let member of selectedClients;let i=index;">
          <div class="form-group msgicofile">
            <div class="input-group court" id="court">
              <p class="form-control textbox msgitemcls">
                <label class="notify_mdg clickable" [class.clickable]="!member.is_deleted" [class.disabled-link]="member.is_deleted"
                    (click)="!member.is_deleted && onClientClick(member)"> {{member.name}}</label>
                <span style="float: right;">
                <!-- <img src="assets/img/mailnotif.svg" class="msgnotify1 mailicocls" (click)="onMailClick()"> &nbsp; -->
                <img src="assets/img/msgico.svg" class="msgnotify1  msgicocls" *ngIf="!member.is_deleted" (click)="onMessageClick(member)"> &nbsp;
                <img src="assets/img/delete.svg" class="msgnotify1 delicocls" (click)="removeClient(member)">
              </span>
              </p>
            </div>
          </div>
        </div>

        <div *ngFor="let member of selectedCorp;let i=index;">
          <div class="form-group msgicofile">
            <div class="input-group court" id="court">
              <p class="form-control textbox msgitemcls">
                <label class="notify_mdg clickable" (click)="onClientClick(member)"> {{member.name}}</label>
                <span style="float: right;">
                <!-- <img src="assets/img/mailnotif.svg" class="msgnotify1 mailicocls" (click)="onMailClick()"> &nbsp; -->
                <img src="assets/img/msgico.svg" class="msgnotify1 msgicocls" (click)="onMessageClick(member)"> &nbsp;
                <img src="assets/img/delete.svg" class="msgnotify1 delicocls" (click)="removeCorp(member)">
              </span>
              </p>
            </div>
          </div>
        </div>
        
        <div class="dashedborder" *ngIf="selectedClients?.length >= 0 && selectedCorp?.length !== 1">
          <!-- <div class="col-4" style="margin-top: 15px;">
            <h6 class="assign" *ngIf="product != 'corporate'">Assign Client(s)</h6>
            <h6 class="assign" *ngIf="product == 'corporate'">Assign External Counsel(s)</h6>
          </div>
          <div class="col-2">
            <div class="form-group" id="selectbx">
              <div class="input-group court" id="search">
                <div class="multicheck form-control textbox">
                  <label class="callselect">Select All</label>
                  <input class="form-check-inpu calimg calitem input-group-append checkboxitem" type="checkbox" value=""
                    id="selectAllClients" (change)="selectAllClients($event)">
                </div>
              </div>
            </div>
          </div> -->

          <div class="row" style="margin-top: 15px;">
            <h6 class="col-6 assign" *ngIf="product != 'corporate'">Assign Client(s)</h6>
            <h6 class="col-6 assign" *ngIf="product == 'corporate'">Assign External Counsel(s)</h6>
            <div class="col-6 selOn" *ngIf="product == 'corporate'">
              <label class="callselect">Select All</label>&nbsp;
              <input type="checkbox" value="" id="selectAllClients" [(ngModel)]="selectAllClientsChecked" (change)="selectAllClients($event)">
            </div>
          </div>

          <div class="form-group">
            <!-- <div class="input-group group-custom-align court" id="search" *ngIf="product != 'corporate'">
              <input type="text" class="form-control textbox" placeholder="Search Client"
                [(ngModel)]="searchTextClient" (keyup)="keyup('clnt')" />
              <img src="assets/img/search.svg" class="calimg calitemo input-group-append searchimg">
            </div> -->
            <div class="input-group group-custom-align court" id="search" *ngIf="product == 'corporate'">
              <input type="text" class="form-control textbox" placeholder="Search External Counsels"
                [(ngModel)]="searchTextClient" (keyup)="keyup('clnt')" />
              <img src="assets/img/search.svg" class="calimg calitemo input-group-append searchimg">
            </div>
          </div>
          <!-- <div class="form-group " id="selectbx ">
            <div class="input-group group-custom-align court" id="search"
              *ngFor="let client of clientsList |filter:searchTextClient">
              <div class="multicheck form-control textbox">
                <div class="callselect" [innerHtml]="client.name"></div>
                <input class="form-check-inpu calimg calitem input-group-app
                                            end checkboxitem" #inputE2 type="checkbox" id="flexCheckDefault"
                  (change)="selectClient(client)">
              </div>
            </div>
          </div> -->

          <div *ngIf="selectedTabItem == 'matter-clients'">

            <div class="col-12 Individual createGroup Indo">
              <div class="row">
 
                <div class="col-12 matterpadding">
                  <!-- <h5 class="float-left grpFont addcli" *ngIf="product !== 'corporate'">Add Client(s)</h5>
                  <h5 class="float-left grpFont" *ngIf="product === 'corporate'">Add External Counsels</h5> -->
                  <!--     
                    <div *ngIf="corporateData && product != 'corporate'">
                      <div class="form-group">
                        <label for="country" class="fontbold alignleft addCC"> Add Corporate Clients </label>
                        <select class="form-select calendorselect" [(ngModel)]="selectedOption" required placeholder="d.ff">
                          <option hidden value="" disabled selected> Select Corporate Clients </option>
                          <option *ngFor="let client of corporateList" class="textbox" [ngValue]="client">{{client.name}}</option>
                        </select>
                      </div>
              
                      <div class="space">
                        <button class="btn btn-primary actionbtn pull-right corpBtn" [disabled]="selectedOption.length == 0"
                          (click)="onClickCorp()">Add to Selected Clients</button>
                      </div>
                    </div> -->

                  <!-- Search Clients -->
                  <div class="input-group court serdiv" id="search">
                    <input type="text" placeholder="Type to Select" matInput class="form-control textbox he"
                      [(ngModel)]="searchText" (ngModelChange)="searchClients(searchText).subscribe()" [formControl]="selectedEntity" (focus)="openPanel()" [matAutocomplete]="auto" matAutocompletePosition="below"
                      (input)="restrictSpaces($event)" />

                    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="onOptSel($event)">
                      <mat-option class="optcls" *ngFor="let option of filteredEntities | async" [value]="option.client_name">
                        {{ option.client_name }}
                      </mat-option>
                    </mat-autocomplete>

                    <button id="btnadd" type="submit" class="input-group-append appendadd"
                      (click)="searchEntity()">Search</button>
                  </div>
                  <span class="warn" *ngIf="showTempForm"> {{searchText}} - not found.</span><br>

                  <!-- Selected Clients Section -->
                  <!-- <div class="selectedone" *ngIf="selectedClients?.length > 0">
                    <h5 class="float-left grpFont">Selected Client(s)</h5>

                    <div class="form-group group-custom-align" *ngFor="let client of selectedClients">
                      <div class="input-group multicheck court" id="selectedgroup">
                        <div class="form-control textbox textAl ipg" [innerHtml]="client.name"></div>

                        <i class="fa fa-regular fa-circle-xmark calimg input-group-append sgroup" aria-hidden="true"
                          (click)="removeClient(client)">
                        </i>
                      </div>
                    </div>
                  </div> -->
                  <!-- Search Clients -->

                  <!-- Corporate lists-->
                  <!-- <div class="form-group" id="selectbx" *ngIf="tempList && tempList.length>0 && product == 'corporate'">
                      <div class="input-group group-custom-align court matterpadding" id="search"
                        *ngFor="let client of corporateList |filter:searchText">
                        <div class="multicheck form-control textbox" *ngIf="!corporateData">
                          <div class="callselect" [innerHtml]="client.name"></div>
                          <input class="form-check-inpu calimg calitem input-group-app
                              end checkboxitem" #inputEl type="checkbox" id="flexCheckDefault"
                            (change)="selectCorporate(client, inputEl.checked)">
                        </div>
                      </div>
                    </div> -->

                  <!-- Temp client added -->
                  <!-- <div *ngIf="product != 'corporate'">
                    <div *ngIf="showTempForm">
                      <span class="warn"> {{searchText}} - not found.</span><br>
                      <span class="warn">Please fill in the details below to add {{searchText}} as client</span>

                      <div clas="form-group">
                        <ul class="nav nav-pills mb-3 btnaction float-left" id="pills-tab" role="tablist">
                          <li class="nav-item">
                            <button id="High" name="individual" class="inde optionhigh"
                              [ngClass]="{'active': selectedType === 'individual'}"
                              (click)="getType($event, 'individual')">Individual</button>
                          </li>
                          <li class="nav-item">
                            <button id="High" name="entity" class="inde optionhigh oent"
                              [ngClass]="{'active': selectedType === 'entity'}"
                              (click)="getType($event, 'entity')">Entity</button>
                          </li>
                        </ul>
                      </div>
                      <div [ngSwitch]="ClientType">
                        <div *ngSwitchCase="'individual'">
                          <form [formGroup]="tempClient" class="formAl" (ngSubmit)="onindividualSubmit('temp')">
                            <div class="form-group">
                              <label for="name" class="fontbold alignleft"> First Name <span class="mandate">*</span> </label>
                              <input formControlName="name" type="text" class="form-control
                                  textbox" id="name" name="name" (input)="restricttextSpace($event)">
                              <div *ngIf="submitted && f0.name.errors" class="invalid-feedback">
                                <div class="warn" *ngIf="f0.name.errors.required">First name is required</div>
                              </div>
                            </div>
                            <div class="form-group">
                              <label for="lastName" class="fontbold alignleft"> Last Name <span class="mandate">*</span> </label>
                              <input formControlName="lastName" type="text" (input)="restricttextSpace($event)"
                                class="form-control textbox" id="lastName" name="lastName">
                              <div *ngIf="submitted && f0.lastName.errors" class="invalid-feedback">
                                <div class="warn" *ngIf="f0.lastName.errors.required">Last name is required</div>
                              </div>
                            </div>
                            <div class="form-group">
                              <label for="email" class="fontbold alignleft">Email Address<span class="mandate">*</span> </label>
                              <input formControlName="email" type="email" (input)="restricttextSpace($event)"
                                class="form-control textbox" id="email" name="email"
                                pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$">
                              <div *ngIf="submitted && f0.email.errors" class="invalid-feedback">
                                <div class="warn" *ngIf="f0.email.errors.required">Email is required</div>
                                <div class="warn" *ngIf="!f0.email.errors.required">Email is invalid</div>
                              </div>
                            </div>
                            <div class="form-group">
                              <label for="confirmemail" class="fontbold alignleft">Confirm Email Address<span
                                  class="mandate">*</span> </label>
                              <input formControlName="confirmemail" type="email" class="form-control textbox" id="confirmemail"
                                name="confirmemail" (input)="restricttextSpace($event)"
                                pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$">
                              <div *ngIf="submitted && f0.confirmemail.errors" class="invalid-feedback">
                                <div class="warn" *ngIf="f0.confirmemail.errors.required">Confirm Email is required</div>
                                <div class="warn" *ngIf="!f0.confirmemail.errors.required">Confirm Email is invalid</div>
                              </div>
                              <div *ngIf="submitted && tempClient.errors?.emailMismatch" class="invalid-feedback">
                                <div class="warn">Confirm Email does not match</div>
                              </div>
                            </div>
                            <div class="form-group">
                              <label for="country" class="fontbold alignleft"> Country <span class="mandate">*</span> </label>
                              <select class="form-control textbox" formControlName="country">
                                <option value="" hidden>Choose </option>
                                <option *ngFor="let city of csvContent" [ngValue]="city">{{city}}</option>
                              </select>
                              <div *ngIf="submitted && f0.country.errors" class="invalid-feedback">
                                <div class="warn" *ngIf="f0.country.errors.required">Country is required</div>
                              </div>
                            </div>
                            <div class="form-group">
                              <label for="phonenumber" class="fontbold alignleft">Phone Number </label>
                              <input formControlName="phonenumber" type="tel" (input)="restricttextSpace($event)"
                                class="form-control textbox" id="phonenumber" name="phonenumber" minlength="10" maxlength="10">
                            </div>

                            <div class="btnbox">
                              <button type="button" class="btn btn-default btncancel btnrightitem" (click)="OnFormCancel()">Cancel</button>
                              <button type="submit" class="btn btn-primary btnsave savecls addTemp">Add as Client</button>
                              <!-- <button type="submit" class="btn btn-primary btnsave savecls" (click)="inputsubmit='invite'">Send Invite</button> --
                            </div>
                          </form>

                        </div>
                        <div *ngSwitchCase="'entity'">
                          <form [formGroup]="entityClient" class="formAl" (ngSubmit)="oneEntitySubmit('entity')">
                            <div class="form-group">
                              <label for="fullname" class="fontbold alignleft"> Firm Name <span class="mandate">*</span> </label>
                              <input formControlName="fullname" type="text" (input)="restricttextSpace($event)"
                                class="form-control textbox" id="fullname" name="fullname">
                              <div *ngIf="entitysubmitted && f1.fullname.errors" class="invalid-feedback">
                                <div class="warn" *ngIf="f1.fullname.errors.required">Firm Name is required</div>
                              </div>
                            </div>
                            <div class="form-group">
                              <label for="contact_person" class="fontbold alignleft">Contact Person<span class="mandate">*</span>
                              </label>
                              <input formControlName="contact_person" type="text" class="form-control textbox" id="contact_person"
                                name="contact_person" (input)="restricttextSpace($event)">
                              <div *ngIf="entitysubmitted && f1.contact_person.errors" class="invalid-feedback">
                                <div class="warn" *ngIf="f1.contact_person.errors.required">Contact Person is required</div>
                              </div>
                            </div>
                            <div class="form-group">
                              <label for="email" class="fontbold alignleft">Email Address<span class="mandate">*</span> </label>
                              <input formControlName="email" type="email" (input)="restricttextSpace($event)"
                                class="form-control textbox" id="email" name="email"
                                pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$">
                              <div *ngIf="entitysubmitted && f1.email.errors" class="invalid-feedback">
                                <div class="warn" *ngIf="f1.email.errors.required">Email is required</div>
                                <div class="warn" *ngIf="!f1.email.errors.required">Email is invalid</div>
                              </div>
                            </div>
                            <div class="form-group">
                              <label for="confirmemail" class="fontbold alignleft">Confirm Email Address<span
                                  class="mandate">*</span> </label>
                              <input formControlName="confirmemail" type="email" class="form-control textbox" id="confirmemail"
                                name="confirmemail" (input)="restricttextSpace($event)"
                                pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$">
                              <div *ngIf="entitysubmitted && f1.confirmemail.errors" class="invalid-feedback">
                                <div class="warn" *ngIf="f1.confirmemail.errors.required">Confirm Email is required</div>
                                <div class="warn" *ngIf="!f1.confirmemail.errors.required">Confirm Email is invalid</div>
                              </div>
                              <div *ngIf="entitysubmitted && entityClient.errors?.emailMismatch" class="invalid-feedback">
                                <div class="warn">Confirm Email does not match</div>
                              </div>
                            </div>
                            <div class="form-group">
                              <label for="country" class="fontbold alignleft"> Country <span class="mandate">*</span> </label>
                              <select class="form-control textbox" formControlName="country">
                                <option value="" hidden>Choose </option>
                                <option *ngFor="let city of csvContent" [ngValue]="city">{{city}}</option>
                              </select>
                              <div *ngIf="entitysubmitted && f1.country.errors" class="invalid-feedback">
                                <div class="warn" *ngIf="f1.country.errors.required">Country is required</div>
                              </div>
                            </div>
                            <div class="form-group">
                              <label for="phonenumber" class="fontbold alignleft">Phone Number </label>
                              <input formControlName="phonenumber" type="tel" (input)="restricttextSpace($event)"
                                class="form-control textbox" id="phonenumber" name="phonenumber" minlength="10" maxlength="10">
                              <!-- <div *ngIf="entitysubmitted && f1.phonenumber.errors" class="invalid-feedback">
                                  <div class="warn" *ngIf="f1.phonenumber.errors.required">Phone Number is required</div>
                                  <div class="warn" *ngIf="!f1.phonenumber.errors.required">Phone Number is invalid</div>
                                </div> --
                            </div>

                            <div class="btnbox">
                              <button type="button" class="btn btn-default btncancel btnrightitem" (click)="OnFormCancel()">Cancel</button>
                              <button type="submit" class="btn btn-primary btnsave savecls addTemp">Add as Client</button>
                              <!-- <button type="submit" class="btn btn-primary btnsave savecls" (click)="inputsubmit='invite'">Send Invite</button> --
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div> -->
                  <!-- Temp client added -->

                </div>

                <!-- <div class="btnbox" *ngIf="!showTempForm">
                  <button type="reset" class="btn btn-default btncancel btnrightitem" (click)="OnCancel()">Cancel</button>
                  <button *ngIf="product != 'corporate'" type="submit" class="btn btnsave savecls"
                    (click)="saveClients()">Save</button>
                  <button *ngIf="product == 'corporate'" type="submit" class="btn btn-primary btnsave savecls"
                    (click)="saveClients()">Next</button>
                </div> -->

              </div>
            </div>

          </div>

        </div>
                  
          <div class="btnbox">
            <button type="reset" class="btn btn-default btncancel btnrightitem" (click)="cancelItems()">Cancel</button>
            <button type="submit" class="btn btn-primary btnsave savecls" (click)="saveItems('clients')"
              [disabled]="isSaveEnableClient || isSavingItems">Save</button>
          </div>
      </div>
    </div>
    <div class="row scrolly" *ngIf="featureName == 'Timeline'">
      <!-- <div class="wrapper">
        <ul class="StepProgress">
          <li class="StepProgress-item " *ngFor="let item of historyData">
            <div class="lgalitem">
              <p class="pnumber pleagalsubitem">{{item.title}}</p>
              <p class="lgalsubitem" *ngIf="item.isrecurring">🔁 Recurring | {{item.recurrence_label}}</p>
              <p class="lgalsubitem" *ngIf="!item.isrecurring">{{item.from_ts}}</p>
              <p class="lgalsubitem" [ngClass]="!item.isNotesElipses? 'noteselipses' : '' ">{{item.notes}}</p>            </div>
              <div class="lgalitemright">
                <img src="assets/img/editico.svg" class="editico" *ngIf="item.id != '' "
                  (click)="notes = item.notes;item.EditDesc=!item.EditDesc" [ngClass]="item.EditDesc? 'onActive' : '' ">
                <img *ngIf="item.notes" src="assets/img/eyesico.svg" class="editico" (click)="item.isNotesElipses = !item.isNotesElipses" [ngClass]="item.isNotesElipses? 'onActive' : '' ">
              </div>
            <div class="c-align c-dec" *ngIf="item.EditDesc && item.id != '' ">
              <textarea [(ngModel)]="notes" rows="3" cols="50" maxlength="1000"></textarea>
              <div class="btnbox">
                <button type="reset" class="btn btn-default btncancel"
                  (click)="item.EditDesc=false;notes = ''">Cancel</button>
                <button type="submit" class="btn btn-default btnsave"
                  (click)="addNotes(item);item.EditDesc=false;item.notes = notes">Save</button>
              </div>
            </div>
          </li>
        </ul>
      </div> -->

      <div class="wrapper">
                  
        <!-- <button class="adde" (click)="categoryRouteGroupName('/meetings/create', data.id)">Add Event</button> -->
        <ul class="StepProgress">
          <li class="StepProgress-item" *ngFor="let item of historyData">
           
            <!-- <div class="lgalitem">
              <p class="pnumber pleagalsubitem">{{item.title}}</p>
              <p class="lgalsubitem">{{item.from_ts | date: 'MMM dd, yyyy | h:mm a'}}</p>
            </div> -->
            <div class="lgalitem">
              <p class="pnumber pleagalsubitem" [class.clickable]="item.id != ''"
                (click)="item.id != '' && openEventPopup($event, item)">
                {{item.title}}
              </p>
              <p class="lgalsubitem">{{item.from_ts | date: 'MMM dd, yyyy | h:mm a' }}</p>
            </div>

            <!--Notes section-->

            <div class="row pad1" *ngIf="item.id != '' ">
              
            <div id="parent">
            <div id="wide" class="radBtn">
              <mat-radio-group [(ngModel)]="isChecked">
                  <mat-radio-button color="primary" id="mainNote" value="mainNote"> <p class="smallRadio">Notes</p> </mat-radio-button>
                  <mat-radio-button color="primary" *ngIf="showCorporateNotes" id="corpNote" value="corpNote" style="margin: 20px;"> <p class="smallRadio">Corporate Notes</p></mat-radio-button>
              </mat-radio-group> 
            </div>
               <!-- <p>selected op: {{isChecked}}</p> -->
              
              <!--Add, Edit Main Notes Action-->
              <div  id="narrow" *ngIf="isChecked === 'mainNote' && mattertype == 'internal'">
                  <button *ngIf="!item.AddDesc" class="plusBtn" (click)="onAdd();notes = item.notes; item.AddDesc = !item.AddDesc; submitted = false;" [disabled]="isButtonClicked">
                    <img src="assets/img/addnotes.svg" class="col-1 addIcon" *ngIf="!item.notes" 
                     matTooltip="Click To Add Notes" [ngClass]="item.AddDesc ? 'onActive' : ''">
                  </button>
             </div>
              <!--Add, Edit Main Notes Action-->

              <!--Add Corporate Notes Action -->
              <div id="narrow" *ngIf="isChecked === 'corpNote' && mattertype != 'internal'">
                <button class="plusBtn" (click)="onAddCN(item);notes = item?.notes_list.notes;item?.notes_list.AddDesc=!item?.notes_list.AddDesc;submitted = false;" [disabled]="isButtonClicked">
                  <img src="assets/img/addnotes.svg" class="col-1 addIcon" *ngIf="!item?.notes_list?.notes" 
                   matTooltip="Click To Add Corporate Notes" [ngClass]="item?.notes_list?.AddDesc? 'onActive' : ''">
                </button>
              </div>
            
           </div>
              <!--Add Corporate Notes Action-->

            
              <!-- Main notes View -->
              <div class="contDiv" *ngIf="isChecked === 'mainNote'">

                <!--Add, Edit Textbox-->
                <div class="c-align c-dec" *ngIf="item.AddDesc || item.EditDesc && item.id != ''">
                  <form [formGroup]="form">
                    <textarea class="row container tex" formControlName="notes" [(ngModel)]="notes" rows="3" cols="50" maxlength="150" oninput="this.value = this.value.replace(/[^A-Za-z0-9-_/#&+()@!$%*|+=?`~<>,. ]|^ /g,'')"></textarea>
                    <div class="count-text">{{ form.get('notes')?.value?.length || 0 }}/150</div>
                    <div *ngIf="form.get('notes').errors && submitted" class="errorStyle">
                      <div *ngIf="form.get('notes').errors.required">Note is required</div>
                    </div>

                    <div class="" style="text-align:end">
                      <button type="reset" class="btn btn-default btncancel"
                        (click)="item.EditDesc=false; item.AddDesc=false; notes = '';isButtonClicked=false;">Cancel</button>
                      <button type="submit" class="btn btn-default btnsave"
                        (click)="item.EditDesc=false; item.AddDesc=false; item.notes = notes;addNotes(item);isButtonClicked=false;"
                        [ngClass]="{ 'disableMode': !form.valid || !form.dirty }"
                        [attr.disabled]="!form.valid || !form.dirty ? true : null">Save</button>
                    </div>
                  </form>
                </div>
                <!--Add, Edit Textbox-->

                <!-- Indication message for !notes -->
                <div *ngIf="!item.AddDesc && !item.notes">
                  <p class="indication">No notes added in this section.</p>
                </div>

                <div class="row container colab" *ngIf="!item.EditDesc && item.notes">
                <!-- <p class="lgalsubitem pad2 textNotes" [ngClass]="!item.isNotesElipses ? 'noteselipses' : ''">{{item?.notes}}</p>
                <a (click)="toggleNotesEllipsis(item)">
                  <u class="readMore">{{!item.isNotesElipses ? 'Read More' : 'Read Less'}}</u>
                </a> -->

                <p class="lgalsubitem pad2 textNotes" [ngClass]="!item.isNotesElipses ? 'noteselipses' : ''">
                  {{ item.isNotesElipses
                  ? item.notes : (item.notes?.length > 50
                  ? (item.notes | slice:0:50) + '...'
                  : item.notes) }}</p>
                <a *ngIf="item.notes?.length > 50" (click)="toggleNotesEllipsis(item)">
                  <u class="readMore">{{ !item.isNotesElipses ? 'Read More' : 'Read Less' }}</u>
                </a>


                <!-- Edit icon for mainNotes-->
                <div class="btnMove" *ngIf="mattertype == 'internal'">
                  <!-- <button class="editBtn" (click)="onAdd();notes = item.notes;item.EditDesc=!item.EditDesc;submitted = false;"
                      [disabled]="isButtonClicked">
                      <i class="fas fa-edit btnMenu editoo" id="btnMove" *ngIf="item.id != ''" matTooltip="Click To Edit Notes"
                        [ngClass]="item.EditDesc ? 'onActive' : ''">
                      </i>
                  </button> -->
                   <button class="btnMenu" id="btnMove" [matMenuTriggerFor]="menu">
                            <i class="fa-solid fa-ellipsis-vertical" style="font-size:1.5rem;"></i>
                          </button>

                          <mat-menu #menu="matMenu">
                            <button mat-menu-item *ngIf="item.id != '' "
                            (click)="onAdd();notes = item.notes;item.EditDesc=!item.EditDesc;submitted = false;" [disabled]="isButtonClicked" 
                            [ngClass]="item.EditDesc? 'onActive' : ''"> Edit</button>
                            <button mat-menu-item (click)="deleteMainNotes(item);" [disabled]="isButtonClicked"> Delete </button>
                          </mat-menu>
                </div>

               </div>

              </div>
              <!-- Main notes View -->
            
              <!-- Corporate notes View-->
              <div class="contDiv" *ngIf="isChecked === 'corpNote'">

                <!-- Indication message for !notes -->
                <div *ngIf="item?.notes_list == '' && !item?.notes_list.AddDesc">
                  <p class="indication">No notes added in this section.</p>
                </div>

                   <!--Add Textbox for Corp. notes -->
                  <div class="c-align c-dec" *ngIf="item?.notes_list.AddDesc">
                    <form [formGroup]="form">
                      <textarea class="row container tex" formControlName="notes" [(ngModel)]="notes" rows="3" cols="50" maxlength="152" oninput="this.value = this.value.replace(/[^A-Za-z0-9-_/#&+()@!$%*|+=?`~<>,. ]|^ /g,'')"></textarea>
                      <div class="count-text">{{ form.get('notes')?.value?.length || 0 }}/150</div>
                      <div *ngIf="form.get('notes').errors && submitted" class="errorStyle">
                        <div *ngIf="form.get('notes').errors.required">Note is required</div>
                      </div>

                      <div class="" style="text-align:end">
                        <button type="reset" class="btn btn-default btncancel"
                          (click)="item?.notes_list.EditDesc=false; item?.notes_list.AddDesc=false; notes = '';isButtonClicked=false;">Cancel</button>
                        <button type="submit" class="btn btn-default btnsave"
                          (click)="item?.notes_list.EditDesc=false; item?.notes_list.AddDesc=false; item?.notes_list.notes = notes;addCorpNotes(item,item.notes_list);isButtonClicked=false;"
                          [ngClass]="{ 'disableMode': !form.valid || !form.dirty }"
                          [attr.disabled]="!form.valid || !form.dirty ? true : null">Save</button>
                      </div>
                    </form>  
                  </div>
                   <!--Add Textbox for Corp. notes -->

                <div *ngFor="let note of item?.notes_list;let i = index">
                    <div class="row container colab">

                      <div class="userprofile usrMove" >
                        <p class="username" >{{note?.added_by[0]}} </p>
                      </div> 
                      <p class="adderName">{{note?.added_by}}</p>
                      <p class="addOn">{{note?.add_on}}</p>

                      <!--Add && Edit textbox oldooo-->
                      <!-- <div class="c-align c-dec" *ngIf="note.AddDesc && note.id != '' ">
                        <textarea [(ngModel)]="notes" rows="3" cols="50" maxlength="152"></textarea>
                        <div class="btnbox">
                          <button type="reset" class="btn btn-default btncancel"
                            (click)="note.EditDesc=false; note.AddDesc=false; notes = ''">Cancel</button>
                          <button type="submit" class="btn btn-default btnsave"
                            (click)="note.EditDesc=false; note.AddDesc=false; note.notes = notes;addCorpNotes(item,note);">Save</button>
                        </div>
                      </div> -->
                      <!--Add && Edit textbox oldooo-->

                      <!--Corp. note Edit textbox-->
                      <div class="c-align c-dec" *ngIf="note.EditDesc && note.id != '' ">
                        <form [formGroup]="form">
                         <textarea class="row container tex" formControlName="notes" [(ngModel)]="notes" rows="3" cols="50" maxlength="152" oninput="this.value = this.value.replace(/[^A-Za-z0-9-_/#&+()@!$%*|+=?`~<>,. ]|^ /g,'')"></textarea>
                         <div class="count-text">{{ form.get('notes')?.value?.length || 0 }}/150</div>
                          <div *ngIf="form.get('notes').errors && submitted" class="errorStyle">
                             <div *ngIf="form.get('notes').errors.required">Note is required</div>
                          </div>

                          <div class="" style="text-align:end">
                            <button type="reset" class="btn btn-default btncancel"
                              (click)="note.EditDesc=false; note.AddDesc=false; notes = '';isButtonClicked=false;">Cancel</button>
                            <button type="submit" class="btn btn-default btnsave"
                              (click)="note.EditDesc=false; note.AddDesc=false; note.notes = notes;updateCorpNotes(item,note);isButtonClicked=false;"
                              [ngClass]="{ 'disableMode': !form.valid || !form.dirty }"
                              [attr.disabled]="!form.valid || !form.dirty ? true : null">Save</button>
                          </div>
                      </form>
                      </div>

                      <!--Corp. note Edit textbox-->

                      <div *ngIf="!note.EditDesc">
                        <p id="limitTextHeight">
                              {{
                              note.isReadMore
                              ? note.notes
                              : (note.notes?.length > 50
                              ? (note.notes | slice:0:50) + '...'
                              : note.notes)
                              }}
                            </p>
                            <a *ngIf="note.notes?.length > 50" class="readMore" (click)="toggleReadMore(note, i)">
                              <u>{{ note.isReadMore ? 'Read Less' : 'Read More' }}</u>
                            </a>
                     </div>

                      <!-- Corp Menu(edit,del) -->
                      <div class="btnMove" *ngIf="product == 'corporate' && mattertype != 'internal'">
                        <button class="btnMenu" id="btnMove" [matMenuTriggerFor]="menu">
                          <i class="fa-solid fa-ellipsis-vertical" style="font-size:1.5rem;"></i>
                        </button>
                        <mat-menu #menu="matMenu">
                          <button mat-menu-item *ngIf="note.id != '' && note.notes"
                          (click)="notes = note.notes;note.EditDesc=!note.EditDesc; onAdd();" [disabled]="isButtonClicked"
                          [ngClass]="note.EditDesc? 'onActive' : ''"> Edit</button>
                         
                          <button mat-menu-item (click)="deleteNotes(item,note);" [disabled]="isButtonClicked"
                          > Delete </button>
                        </mat-menu>
                      </div>
                      <!-- Corp Menu(edit,del) -->

                    </div>
                </div> 
              </div>
              <!-- Corporate notes View-->
                
            </div>

            <!--Notes section-->
          </li>
        </ul>
      </div>


    </div>

    <!-- Timesheet div -->
    <div class="row scrolly" *ngIf="featureName == 'Timesheets'">
      <div class="wrapper">
    
        <div class="tsHeaderRow">
          <h5 class="cname cout tsHeaderTitle">Timesheets</h5>
          <div class="tsHeaderActions">
            <button class="btn btn-default btnWeekNav" (click)="onWeekChange('prev','timesheet')">
              <i class="fa fa-chevron-left"></i>
            </button>
            <span class="tsWeekRange">
              {{timesheetWeekDays[0]?.dateLabel}} - {{timesheetWeekDays[timesheetWeekDays.length - 1]?.dateLabel}}
              <!-- <img src="assets/img/calendor.svg" class="tsCalIcon" (click)="openWeekPicker('timesheet')"> -->
            </span>
            <button class="btn btn-default btnWeekNav" (click)="onWeekChange('next','timesheet')">
              <i class="fa fa-chevron-right"></i>
            </button>
            <button class="btn btn-primary btnAddTS" (click)="onAddTimesheet()">
              <i class="fa fa-plus"></i> Add Timesheet
            </button>
          </div>
        </div>
    
        <div class="tsTableWrapper">
          <table class="table tsTable">
            <thead>
              <tr>
                <th class="tsTeamMemberCol" *ngIf="catsolo !== 'solo'">Team Member</th>
                <th class="tsTaskCol">{{timesheetHeaders.header2 || 'Task'}}</th>
                <th class="tsTaskCol">Status</th>
                <th *ngFor="let day of timesheetWeekDays">
                  {{day.label}}<br>{{day.dateLabel}}
                </th>
                <th class="tsTotalCol">{{timesheetHeaders.header3 || 'Total'}}</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let member of timesheetMembers">
                <tr *ngFor="let task of member.tasks; let tIndex = index">
                  <td *ngIf="tIndex === 0 && catsolo !== 'solo'" [attr.rowspan]="member.tasks.length" class="tsMemberCell">
                    <div class="tsMemberRow">
                      <span class="tsAvatar">{{ getInitials(member?.userName) }}</span>
                      <span class="tsMemberInfo">
                        <span class="tsMemberName">{{member.userName}}</span>
                        <span class="tsMemberRole" *ngIf="member.role"><br>{{member.role}}</span>
                      </span>
                    </div>
                  </td>
    
                  <td class="tsTaskCell" *ngIf="taskRowspan(member.tasks, tIndex) > 0"
                      [attr.rowspan]="taskRowspan(member.tasks, tIndex)">{{task.taskName}}</td>
                  <td class="tsTaskCell">{{task.billing}}</td>
    
                  <td *ngFor="let day of timesheetWeekDays" class="tsDayCell">
                    <ng-container *ngIf="task[day.label]?.taskId; else noTsEntry">
                      <span class="tsHoursDot"></span> <span class="tsTimeLabel"
                        (click)="viewTimesheet(member, task, day.label)">{{ formatDuration(task[day.label]) }}</span><br>
                    </ng-container>
                    <ng-template #noTsEntry>
                      <a class="tsAddLink" *ngIf="isTimesheetDayAllowed(day.dateLabel)"
                        (click)="addTimesheet(member, task, day.label)"><i
                          class="bi bi-pencil-fill"></i></a>
                    </ng-template>
                  </td>
    
                  <td class="tsTotalCell">{{formatTotal(task.total)}}</td>
                </tr>
              </ng-container>
            </tbody>
            <tfoot>
              <tr class="tsWeeklyTotalRow">
                <td colspan="1" *ngIf="catsolo !== 'solo'">Total</td>
                <td colspan="1">{{catsolo === 'solo' ? 'Total' : ''}}</td>
                <td colspan="1"></td>
                <td *ngFor="let day of timesheetWeekDays">{{ formatTotal(timesheetWeekTotalsByDay[day.label]) }}</td>
                <td>{{formatTotal(timesheetWeeklyTotal)}}</td>
              </tr>
            </tfoot>
          </table>
        </div>
    
      </div>
    </div>
    
    <!-- Add / View / Edit Timesheet Modal -->
    <div class="tsModalOverlay" *ngIf="showAddTimesheetModal">
      <div class="tsModalCard">
        <div class="tsModalHeader">
          <h5 class="tsModalTitle">
            {{ tsModalMode === 'view' ? 'View Timesheet' : tsModalMode === 'edit' ? 'Edit Timesheet' : 'Add Timesheet' }}
            - {{ data?.title }}
            <i class="bi bi-pencil" *ngIf="tsModalMode === 'view'" (click)="switchToEditMode()"></i>
          </h5>
          <i class="fa-solid fa-xmark tsModalClose" (click)="closeAddTimesheetModal()"></i>
        </div>
    
        <!-- VIEW MODE: read-only, no form controls, no action buttons -->
        <div class="tsFormGrid" *ngIf="tsModalMode === 'view'">
          <div class="tsFormGroup">
            <label>Matter</label>
            <div class="tsViewValue">{{ addTimesheetForm.get('matter_type')?.value || data?.title }}</div>
          </div>
    
          <div class="tsFormGroup">
            <label>Task</label>
            <div class="tsViewValue">{{ addTimesheetForm.get('title')?.value }}</div>
          </div>
    
          <div class="tsFormGroup">
            <label>Status</label>
            <div class="tsViewValue">
              {{ addTimesheetForm.get('billing')?.value === 'billable' ? 'Billable' : 'Non Billable' }}
            </div>
          </div>
    
          <div class="tsFormGroup">
            <label>Date</label>
            <div class="tsViewValue">{{ addTimesheetForm.get('date')?.value }}</div>
          </div>
    
          <div class="tsFormGroup">
            <label>Hours</label>
            <div class="tsViewValue">{{ addTimesheetForm.get('duration_hours')?.value }}</div>
          </div>
    
          <div class="tsFormGroup">
            <label>Minutes</label>
            <div class="tsViewValue">{{ addTimesheetForm.get('duration_minutes')?.value }}</div>
          </div>
        </div>
    
        <!-- ADD / EDIT MODE: full editable form -->
        <form [formGroup]="addTimesheetForm" (ngSubmit)="onSubmitAddTimesheet()"
          *ngIf="tsModalMode === 'add' || tsModalMode === 'edit'">
          <div class="tsFormGrid">
    
            <div class="tsFormGroup">
              <label>Matter</label>
              <input type="text" class="form-control matform" formControlName="matter_type" readonly>
            </div>
    
            <div class="tsFormGroup">
              <label>Task</label>
              <select class="form-select" formControlName="title">
                <option hidden value="">Select</option>
                <option *ngFor="let t of tsTasks" [value]="t.displayValue">{{ t.displayValue }}</option>
              </select>
              <div class="tsFieldError" *ngIf="addTsSubmitted && addTimesheetForm.get('title')?.errors?.['required']">
                Task is required
              </div>
            </div>
    
            <div class="tsFormGroup">
              <label>Status</label>
              <select class="form-select" formControlName="billing">
                <option hidden value="">Select</option>
                <option *ngFor="let h of tsHoursOptions" [value]="h.returnValue">{{ h.name }}</option>
              </select>
              <div class="tsFieldError" *ngIf="addTsSubmitted && addTimesheetForm.get('billing')?.errors?.['required']">
                Status is required
              </div>
            </div>
    
            <div class="tsFormGroup">
              <label>Date</label>
              <select class="form-select" formControlName="date">
                <option value="" disabled hidden>Select</option>
                <option *ngFor="let d of selectableTimesheetDays" [value]="d.dateLabel">
                  {{ d.dateLabel }}
                </option>
              </select>
              <div class="tsFieldError" *ngIf="!selectableTimesheetDays.length">
                This week is before the matter was created.
              </div>
            </div>
    
            <div class="tsFormGroup">
              <label>Hours</label>
              <input type="number" min="0" max="24" class="form-control" formControlName="duration_hours">
            </div>
    
            <div class="tsFormGroup">
              <label>Minutes</label>
              <select class="form-select" formControlName="duration_minutes">
                <option *ngFor="let m of tsMinutesOptions" [value]="m.returnValue">{{ m.name }}</option>
              </select>
            </div>
    
          </div>
    
          <div class="tsModalActions">
            <button type="button" class="btn btn-default cancelbtn" (click)="closeAddTimesheetModal()">Cancel</button>
            <button type="submit" class="btn btn-primary savebtn"
              [disabled]="addTimesheetForm.invalid || isDurationEmpty()">
              {{ tsModalMode === 'edit' ? 'Update' : 'Save' }}
            </button>
          </div>
        </form>
    
      </div>
    </div>

  </div>
  <div class="col-xs-12 col-sm-12 col-md-6" *ngIf="featureName != 'Document' && featureName != 'Timesheets' && featureName != 'Tasks'">
    <!-- component right side -->
    <div class="row containerbox">
      <div class="col-sm-12">
        <div class="container">
          <div class="row inforowaling">
            <!-- arrow toggel begin-->
            <div class="col-sm-1 arrowcolumn" [ngClass]="isVisibleInfo? 'poschng' : '' ">
              <div class="infocontainerleft">
                <p class="arrowtoggel" id="btntgl" (click)="isVisibleInfo=!isVisibleInfo">
                  <img src="assets/img/arrowdown.svg" class="slidearrowtgl">
                </p>
              </div>
            </div>
            <!-- arrow toggel end -->
            <!-- form summary compoenent -->
            <div *ngIf="!isVisibleInfo" class="col-sm-11 infoconalign">
              <div class="infocontainer" id="formtglfiv">
                <div class="row summarycontainer">
                  <div class="col-sm-6">
                    <p class="psize">Summary</p>
                  </div>
                  <!-- <div class="col-sm-6">
                <div class="hearingimg">
                  <img src="img/formcalendor.svg" class="formcal">
                </div>
                <div class="itemhearing">
                  <p class="hearing">Hearing </p>
                  <p class="hearingdate">Mar 30 2022</p>
                </div>
              </div> -->
                </div>
                <!-- for edit form 1 castitle -->
                <div class="form-group">
                  <div class="row summarycontainer">
                    <div class="col-sm-6">
                      <label for="title" class="editcase">Case Title <span class="mandate">*</span>
                      </label>
                      <div class='editable' id='txt1'>{{data.title}}</div>
                    </div>
                    <div class="col-sm-6"><!--*ngIf="data?.type == 'internal'"-->
                      <input type='button' class="btn btn-primary float-right ebtn" id='but_enable' value='Edit'
                      (click)="matterInfoEdit()">
                    </div>
                  </div>
                </div>
                <!-- for edit summary case number -->
                <div class="form-group summarycitem">
                  <label for="title" class="editcase">Matter Number <span class="mandate">*</span>
                  </label>
                  <div class='editable cnumber'>{{data.matter_id}}</div>
                </div>
                <!-- for edit summary case type -->
                <div class="form-group summarycitem">
                  <label for="title" class="editcase">Created Date </label>
                  <div class='editable cnumber'>{{data?.created_date | date:'MMM dd, yyyy'}}</div>
                </div>
                <!-- for edit summary case type -->
                <div class="form-group summarycitem">
                  <label for="title" class="editcase">Matter Type </label>
                  <div class='editable cnumber'>{{data.matterType}}</div>
                </div>
                <!-- for edit summary date of filling-->
                <div class="form-group summarycitem">
                  <label for="title" class="editcase">Start Date</label>
                  <div class='editable cnumber'>{{data.startdate | date: 'MMM d, YYYY'}}</div>
                </div>
                <div class="form-group summarycitem">
                  <label for="title" class="editcase">Close Date</label>
                  <div class='editable cnumber'>{{data.matterClosedDate || data.closedate}}</div>
                </div>
                <!-- for edit summary Description-->
                <div class="form-group summarycitem">
                  <label for="title" class="editcase">Description </label>
                  <div class='editable cnumber'>{{data.description}}</div>
                </div>
                <!-- for edit summary matter-->
                <div class="form-group summarycitem">
                  <label for="title" class="editcase">Matter Tags </label>
                  <div class='editable cnumber'>
                    <div *ngFor="let tag of getTagList(data.tags)">
                      {{ tag }}
                    </div>
                  </div>
                </div>
                <!-- for edit summary status-->
                <div class="form-group Judges summarycitem">
                  <div class="statusprior">
                    <label for="title" class="editcase"> Status </label>
                    <div class='editable cnumber'>{{data.status}}</div>
                  </div>
                  <div class="statusprior">
                    <label for="title" class="editcase"> Priority </label>
                    <div class='editable cnumber'>{{data.priority}}</div>
                  </div>
                </div>
              </div>
            </div>
            <!-- form summary compoenent ends -->
          </div>
        </div>
        <!-- ends here -->
      </div>
    </div>
  </div>
  <div class="row " *ngIf="featureName == 'Document'">
    <div class="col-6">
      <ul class="nav nav-pills mb-3 btnaction float-left " id="pills-tab" role="tablist">
        <!-- <li class="nav-item" *ngIf="data?.type == 'internal'">
          <button id="High" name="priority" class="selectprior optionhigh addnew" id="pills-home-tab" data-bs-toggle="pill"
            data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="false"
            [ngClass]="isNewDocument? 'active' : '' "
            (click)="onFeatureAddNewDoc('Document');isNewDocument= !isNewDocument;AddExistingSelected = false;UploadDocSelected=true;">Add New +</button>
        </li> -->
      </ul>
    </div>
    <div class="col-6"></div>
  </div>
  <div class="row" *ngIf="featureName == 'Document'">
    <div class="col-6" *ngIf="isNewDocument && !AddExistingSelected">
      <!-- <h5 class="cname cout">Attach Document(s)</h5> -->
      <ul class="nav nav-pills mb-3 btnaction float-left " id="pills-tab" role="tablist">
        <!-- <li class="nav-item">
          <button id="High" name="priority" class="selectprior optionhigh active" id="pills-home-tab" [ngClass]="{'active':AddExistingSelected}"
            data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home"
            aria-selected="true" (click)="AddExistingSelected=true;UploadDocSelected=false">Add Existing</button>
        </li> -->
        <!-- <li class="nav-item" *ngIf ="product !='corporate'">
          <button id="Medium" name="priority" class="selectprior optionaling" id="pills-profile-tab" [ngClass]="{'active':UploadDocSelected}"
            data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile"
            aria-selected="false" (click)="UploadDocSelected=true;AddExistingSelected=false;onUploadCancel();">Upload New</button>
        </li> -->
      </ul>
    </div>
    <div class="compswitch" *ngIf="isNewDocument && AddExistingSelected">
      <div class="row">
        <div class="col-5">
          <h6 class="cname" style="float: left;">Selected Document(s)</h6>
          <div> <!--  *ngIf="selectedDocuments?.length>0" -->
            
            <div class="row" *ngFor="let document of selectedDocuments">
              <div class="col-6 docname">{{document.name}}</div>
              <div class="col-6 docremove"><i class="fa fa-regular fa-circle-xmark calimg input-group-append sgroup" aria-hidden="true"
                (click)="removeDocument(document)"></i></div>
            </div>

            <!-- <table class="table table-borderless tblgrid">
              <thead>
                <tr class="theader">
                  <th>
                    <p class="thheadname" style="color: #0B5A9A;">Name</p>
                  </th>
                  <th>
                    <p class="thheadname" style="color: #0B5A9A;">Description</p>
                  </th>
                  <th>
                    <p class="thheadname" style="color: #0B5A9A;">Tags</p>
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr class="rone" *ngFor="let document of selectedDocuments">
                  <td class="tabclass">{{document.name}}</td>
                  <td class="tabclass">{{document.description}}</td>
                  <td class="tabclass" *ngIf="document?.tags && document.tags.length>0" [innerHTML]="document?.tags[0]"></td>
                  <td  class="tabclass"*ngIf="!(document?.tags?.length>0)"></td>
                  <td class="tabclass"><i class="fa fa-regular fa-circle-xmark calimg input-group-append sgroup" aria-hidden="true"
                    (click)="removeDocument(document)"></i></td>
                </tr>
              </tbody>
            </table> -->
          </div>
        </div>
        <div class="col-1"></div>
        <!-- <div class="col-6" style="margin-top: -90px;">

          <div class="form-group float-right">
            <div class="input-group court grpo" id="search">
              <input type="text" class="form-control textbox" placeholder="Search" [(ngModel)]="searchText" (keyup)="keyup('doc')" />
              <img src="assets/img/search.svg" class="calimg calitemo input-group-append searchimg">
            </div>
          </div>

          <div class="col-3 uplo">
            <h6 class="cname">Uploaded Document(s)</h6>
          </div>
          <div class="col-3" style="float: right">
            <div class="form-group" id="selectbx">
              <div class="input-group court" id="search" style="margin-top: -48px;">
                <div class="multicheck form-control textbox selectDoc">
                  <label class="callselect selAll">Select All</label>&nbsp;
                  <input class="form-check-inpu calimg input-group-append checkboxitem" type="checkbox" value=""
                    id="selectAll" (change)="selectAll($event)">
                </div>
              </div>
            </div>
          </div>
          <table class="table table-borderless tblgrid">
            <thead>
              <tr class="theader">
                <th>
                  <p class="thheadname" style="color: #0B5A9A;">Name</p>
                </th>
                <th>
                  <p class="thheadname" style="color: #0B5A9A;">Description</p>
                </th>
                <th>
                  <p class="thheadname" style="color: #0B5A9A;">Tags</p>
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr class="rone" *ngFor="let document of documentsList |filter:searchText">
                <td class="tabcl">{{document.name}}</td>
                <td class="tabcl">{{document.description}}</td>
                <td class="tabcl" *ngIf="document?.tags && document.tags.length>0" [innerHTML]="document?.tags[0]"></td>
                <td class="tabcl" *ngIf="!(document?.tags?.length>0)"></td>
                <td class="tabcl"><input class="" type="checkbox" id="flexCheckDefault" (change)="selectDocument(document)"></td>
              </tr>
            </tbody>
          </table>
        </div> -->
        <div class="btnbox">
          <button type="reset" class="btn btn-default btncancel btnrightitem"
            (click)="cancelDocuments()">Cancel</button>
          <button type="submit" class="btn btn-primary btnsave savecls" (click)="saveDocuments()">Submit</button>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="isNewDocument && UploadDocSelected">
  
  <!-- Client and Matter Information Row -->
  <!-- <div class="row doco">
    <div class="col-6 docclients holeClient">
      Client Name | <b style="color:#00498E">{{ clientNamesString }}</b> 
      <a class="viewmore" *ngIf="filteredClients?.length>1" (click)="toggleClientNames()">
        {{ showAllClients ? 'View Less' : 'View More' }}
      </a>
    </div>              
    <div class="col-6 docmatter holeMatter">
      Matter | <b style="color:#00498E">{{ data?.title }}</b>
    </div>
  </div> -->

  <div class="col-12 Individual createGroup inn">
  
  <!-- Upload Section -->
  <div class="upload-section-modern">
    <div class="form-group" style="width: 100% !important">
      <label for="file-upload" class="form-label">
        <span *ngIf="uploadedDocs.length == 0">
          <!-- Select Document(s) <span class="mandate">*</span> -->
          <h5 class="cname cout ct2">Attach Document(s)</h5>
        </span>
        <span *ngIf="uploadedDocs.length > 0">
          Selected Document(s) to upload <span class="mandate">*</span>
        </span>
      </label>

      <div class="upload-dropzone"
           (dragover)="onDragOver($event)"
           (dragleave)="onDragLeave($event)"
           (drop)="onDrop($event)"
           [class.drag-over]="isDragOver">

        <input #fileInput type="file" multiple hidden (change)="handleFileInput($event)" />

        <div class="dropzone-content" (click)="fileInput.click()">
          <!-- <div class="upload-icon-wrapper">
            <i class="fa fa-upload upload-icon"></i>
          </div>
          <div class="dropzone-text-wrapper">
            <p class="dropzone-text">
              Drag and drop or <span class="browse-link">browse</span>
            </p>
            <p class="file-types">PDF, DOC, DOCX, JPG, PNG</p>
          </div> -->
          <div class="dropzone-text-wrapper">
            <div class="upload-icon"><i class="fas fa-cloud-upload-alt"></i></div>
            <p class="dropzone-text">
              Choose the files you want to upload from your device or
              <br>
              drag & drop them here
            </p>
            <button type="button" class="browse-btn">Browse Files</button>
          </div>
          
        </div>
      </div>
    </div>
  </div>

  <!-- Selected Documents Section - Shows immediately after file selection -->
  <div class="selected-documents-section">
    <h2 class="section-title" *ngIf="uploadedDocs.length > 0">
      Selected Document(s)
      <span class="document-count">({{uploadedDocs.length}})</span>
    </h2>
    
    <!-- Document Cards Container -->
    <div class="document-cards-container">
      <div class="document-card" *ngFor="let item of uploadedDocs; let i = index"
           [ngClass]="{'expanded': selectedIdx === i}">
        
        <!-- Document Header (Always Visible) -->
        <div class="document-header">
          <div class="doc-info">
            <i class="fa fa-file-text doc-icon"></i>
            <div class="doc-details">
              <div class="doc-name">{{item.name}}</div>
              <div class="doc-size">{{ (item.size / 1024) | number:'1.2-2' }} KB</div>
            </div>
          </div>
          <div class="doc-actions">
            <i class="fas fa-edit action-icon edit-icon" (click)="editDocument(item, i)"
               matTooltip="Edit metadata"></i>
            <i class="fa fa-trash action-icon trash-icon" (click)="removeNewDocument(item, i)"
               matTooltip="Remove document"></i>
          </div>
        </div>

        <!-- Document Metadata Form (Collapsible) -->
        <div class="document-metadata" *ngIf="selectedIdx === i && editDoc">
          <hr class="divider">

          <form [formGroup]="documentDetail" (ngSubmit)="onSubmit()">
            <div class="row metadata-row">

              <!-- Left Column -->
              <div class="col-6">
                <div class="form-group">
                  <label for="documentName" class="form-label">
                    Document Name <span class="mandate">*</span>
                  </label>
                  <input type="text"
                         class="form-control textbox docfield"
                         id="documentName"
                         name="documentName"
                         formControlName="name"
                         [maxLength]="50"
                         (input)="restricttextSpace($event)"
                         oninput="this.value = this.value.replace(/[^A-Za-z0-9-()._ ]|^ /g,'')"
                         [ngClass]="{'is-invalid': submitted && f.name.errors}"
                         autocomplete="off">

                  <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
                    <div *ngIf="f.name.errors.required">Document Name is required</div>
                  </div>

                  <div class="char-counter" *ngIf="f.name.value">
                    {{f.name.value.length}}/50
                  </div>
                </div>

                <div class="form-group">
                  <label for="description" class="form-label">
                    Description
                  </label>
                  <textarea rows="4"
                            class="form-control textbox docfield"
                            formControlName="description"
                            name="description"
                            (input)="restricttextSpace($event)"
                            oninput="this.value = this.value.replace(/[^A-Za-z0-9-()._ ]|^ /g,'')"
                            maxlength="300"
                            placeholder="Add description"></textarea>

                  <div class="char-counter" *ngIf="f.description.value">
                    {{f.description.value.length}}/300
                  </div>
                </div>
              </div>

              <!-- Right Column -->
              <div class="col-6">
                <!-- <div class="form-group expiration-field">
                  <label for="expiration-date" class="form-label">
                    Expiration Date <span class="optional-label">(Optional)</span>
                  </label>
                  <div class="date-input-wrapper">
                    <input type="text"
                           class="form-control textbox date-input"
                           [matDatepicker]="picker"
                           placeholder="Choose a date"
                           formControlName="date_of_filling"
                           [min]="minDate"
                           readonly />
                    <mat-datepicker-toggle matSuffix [for]="picker" class="date-toggle">
                      <mat-icon matDatepickerToggleIcon class="calendar-icon">
                        <i class="fa-regular fa-calendar"></i>
                      </mat-icon>
                    </mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </div>
                </div> -->
                <div class="form-group expiration-field">
                  <label for="expiration-date" class="form-label">
                    Expiration Date <span class="optional-label">(Optional)</span>
                  </label>
                
                  <div class="custom-date-wrapper">
                    <input #expiryDp="bsDatepicker" bsDatepicker [bsConfig]="expirationDatePickerConfig"
                      formControlName="date_of_filling" class="form-control textbox date-input custom-input" placeholder="Choose a date"
                      readonly />
                
                    <button class="icon-btn date-toggle" type="button" (click)="expiryDp.toggle(); $event.stopPropagation()">
                      <i class="fa-regular fa-calendar calendar-icon"></i>
                    </button>
                  </div>
                </div>

                <div class="toggle-row">
                  <div class="toggle-box">
                    <span class="toggle-label">Encryption</span>
                    <span class="toggle-switch"
                          [class.active]="item.custom_encrypt"
                          (click)="encrypttoggle(item, item.custom_encrypt)">
                    </span>
                  </div>

                  <div class="toggle-box">
                    <span class="toggle-label">Download</span>
                    <span class="toggle-switch"
                          [class.active]="item.downloadDisabled"
                          (click)="disableDoc(item, item.downloadDisabled)">
                    </span>
                  </div>
                </div>

                <!-- Tags Section -->
                <div class="tags-section">
                  <label class="form-label">
                    Tags <span class="optional-label">(Optional)</span>
                  </label>

                  <div class="tags-container" *ngIf="showTagInputs">
                    <div class="tag-row" *ngFor="let value of currentDocTags; let i = index">
                      
                      <!-- TAG TYPE -->
                      <div class="tag-input-block">
                        <input type="text"
                               class="tag-input"
                               placeholder="Tag type"
                               [(ngModel)]="value.tagtype"
                               (ngModelChange)="checkDuplicateTagType(i)"
                               [ngModelOptions]="{ standalone: true }"
                               maxlength="30" />
                        <div class="char-counter" *ngIf="value.tagtype">
                          {{ value.tagtype.length }}/30
                        </div>
                      </div>

                      <!-- TAG VALUE -->
                      <div class="tag-input-block">
                        <input type="text"
                               class="tag-input tag-value-input"
                               placeholder="Tags"
                               [(ngModel)]="value.tag"
                               [ngModelOptions]="{ standalone: true }"
                               maxlength="100" />
                        <div class="char-counter" *ngIf="value.tag">
                          {{ value.tag.length }}/100
                        </div>
                      </div>

                      <!-- REMOVE -->
                      <i class="fa-solid fa-xmark remove-tag" (click)="removeTagRow(i)"></i>
                    </div>
                  </div>

                  <button type="button" class="add-tag-btn" (click)="addTagRow()">
                    <i class="fa fa-plus"></i> Add Tags
                  </button>
                </div>

              </div>

            </div>

            <!-- Action Buttons -->
            <div class="form-actions">
              <button type="button" class="btns btn-secondary" (click)="cancelEdit()">Cancel</button>
              <button type="submit" class="btns btn-primary">Save</button>
            </div>

          </form>
        </div>

      </div>
    </div>

    <!-- Main Upload Action Buttons -->
    <div class="row main stepitem" *ngIf="!editDoc">
      <div class="col-sm-12">
        <div class="btnbox">
          <button type="reset" class="btn btn-default btncancel" (click)="onUploadCancel()">Cancel</button>
          <button type="submit" class="btn btn-default btnsave savecls uploadClass"  
                  [ngClass]="{disabled: uploadedDocs.length == 0}"
                  (click)="saveUploadedDocuments()">Upload</button>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
    <div *ngIf="!isNewDocument">
      <!-- <button id="High" name="priority" class="selectprior optionhigh" id="pills-home-tab" data-bs-toggle="pill"
        data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="false"
        [ngClass]="isMergeEnable? 'active' : '' " (click)="isMergeEnable= !isMergeEnable;onMergeClick();">Merge</button> -->
      <br />
      <input *ngIf="isMergeEnable" type="checkbox" id="mergeSelectAll" #inputE3 class="larger" name="checkBox2" (change)="CheckAllOptions(inputE3.checked)">

      <ul class="nav nav-tabs" id="document-source-tabs" role="tablist" *ngIf="isMarketplace===true">
        <li class="nav-item">
            <button 
            class="selectprior optionhigh" 
            [class.active]="activeDocTab === 'Marketplace'"
            (click)="onFeatureClick('Document', 'Marketplace')">
            Added by Marketplace
          </button>
        </li>
        <li class="nav-item">
          <button 
          class="selectprior optionaling cbtn" 
          [class.active]="activeDocTab === 'Lauditor'"
          (click)="onFeatureClick('Document', 'Lauditor')">
          Added by Lex-Z Lawyers
        </button>
        </li>
      </ul>

      <!-- <table class="table table-borderless tblgrid">
        <thead>
          <tr class="theader">
            <th>
              <p class="thheadname">Document Name</p>
              <img src="assets/img/SORT.PNG" class="sortico" (click)="sort('name',selectedDocuments)">
            </th>
            <th>
              <p class="thheadname">Description</p>
              <img src="assets/img/SORT.PNG" class="sortico" (click)="sort('description',selectedDocuments)">
            </th>
            <th>
              <p class="thheadname">Added On</p>
              <img src="assets/img/SORT.PNG" class="sortico" (click)="sort('created',selectedDocuments)">
            </th>
            <th>
              <p class="thheadname">Added By</p>
              <img src="assets/img/SORT.PNG" class="sortico" (click)="sort('addedBy',selectedDocuments)">
            </th>
            <th>
              <p class="thheadname">Tags</p>
              <img src="assets/img/SORT.PNG" class="sortico" (click)="sort('tags',selectedDocuments)">
            </th> 
            <th>
              <p class="thheadname textport">View</p>
            </th>
            <th>
              <p class="thheadname textport">Remove</p>
            </th>
          </tr>
        </thead>
        <tbody *ngIf="activeDocTab === 'Lauditor'">
          <tr class="rone veiw-items" *ngFor="let doc of selectedDocuments | filter:searchDocument">
            <td class="tabclass doco dd">{{doc.name}}</td>
            <td class="tabclass doco dd">{{doc.description}}</td>
            <td class="tabclass">{{doc.created | date: 'MMMM dd, yyyy'}}</td>
            <td class="tabclass">{{doc.addedBy}}</td>
            <td class="tabclass">
              <ng-container *ngIf="doc.tags">
                <div class="tagsAl" *ngFor="let key of objectKeys(doc.tags)">{{ key }}, {{ doc.tags[key] }}</div>
              </ng-container>
            </td>
            <td class="tabclass"><img (click)="viewDocument(doc)" src="assets/img/eyesico.svg"/></td>
            <td class="tabclass"><i (click)="documentDelete(doc)" *ngIf="data?.type == 'internal'"  class="fa fa-regular fa-circle-xmark calimg input-group-append sgroup" aria-hidden="true"></i></td>
          </tr>
        </tbody>
                
        <tbody *ngIf="activeDocTab === 'Marketplace'">
          <tr class="rone veiw-items" *ngFor="let doc of selectedDocuments |filter:searchText">
            <td class="tabclass doco dd">{{doc.name}}</td>
            <td class="tabclass doco dd">{{doc.description}}</td>
            <td class="tabclass">{{doc.created | date: 'MMMM dd, yyyy'}}</td>
            <td class="tabclass">{{doc.addedBy}}</td>
            <td class="tabclass">
              <ng-container *ngIf="doc.tags">
                <div *ngFor="let key of objectKeys(doc.tags)">{{ key }}, {{ doc.tags[key] }}</div>
              </ng-container>
            </td>
            <td class="tabclass"><img (click)="viewDocument(doc)" src="assets/img/eyesico.svg"/></td>
            <td class="tabclass"><i (click)="documentDelete(doc)" *ngIf="data?.type == 'internal'"  class="fa fa-regular fa-circle-xmark calimg input-group-append sgroup" aria-hidden="true"></i></td>
          </tr>
        </tbody>
      </table> -->

      <div class="">
        <table class="head-table">
          <thead>
            <tr>
              <th>
                <div class="th-content">
                  <span>Document Name</span>
                  <img src="assets/img/SORT.PNG" class="sort-icon" (click)="sort('name',selectedDocuments)" alt="Sort">
                </div>
              </th>
              <th>
                <div class="th-content">
                  <span>Description</span>
                  <img src="assets/img/SORT.PNG" class="sort-icon" (click)="sort('description',selectedDocuments)" alt="Sort">
                </div>
              </th>
              <th>
                <div class="th-content">
                  <span>Added On</span>
                  <img src="assets/img/SORT.PNG" class="sort-icon" (click)="sort('created',selectedDocuments)" alt="Sort">
                </div>
              </th>
              <th>
                <div class="th-content">
                  <span>Added By</span>
                  <img src="assets/img/SORT.PNG" class="sort-icon" (click)="sort('addedBy',selectedDocuments)" alt="Sort">
                </div>
              </th>
              <th>
                <div class="th-content">
                  <span>Tags</span>
                  <img src="assets/img/SORT.PNG" class="sort-icon" (click)="sort('tags',selectedDocuments)" alt="Sort">
                </div>
              </th>
              <th></th>
            </tr>
          </thead>
      
          <tbody *ngIf="activeDocTab === 'Lauditor'">
            <tr *ngFor="let doc of selectedDocuments | filter:searchDocument" class="table-row">
              <td>{{doc.name}}</td>
              <td>{{doc.description}}</td>
              <td>{{doc.created | date: 'MMMM dd, yyyy'}}</td>
              <td>{{doc.addedBy}}</td>
      
              <td>
                <ng-container *ngIf="doc.tags">
                  <div class="tagsAl" *ngFor="let key of objectKeys(doc.tags)">{{ key }}, {{ doc.tags[key] }}</div>
                </ng-container>
              </td>
      
              <td class="action-cell">
                <button mat-icon-button class="action-btn" [matMenuTriggerFor]="actionMenu">
                  <span class="action-dots">⋮</span>
                </button>
      
                <mat-menu #actionMenu="matMenu" class="custom-mat-menu">
                  <button mat-menu-item (click)="viewDocument(doc)">View</button>
                  <button mat-menu-item (click)="documentDelete(doc)">Delete</button>
                </mat-menu>
              </td>
            </tr>
          </tbody>
      
          <tbody *ngIf="activeDocTab === 'Marketplace'">
            <tr *ngFor="let doc of selectedDocuments | filter:searchDocument" class="table-row">
              <td>{{doc.name}}</td>
              <td>{{doc.description}}</td>
              <td>{{doc.created | date: 'MMMM dd, yyyy'}}</td>
              <td>{{doc.addedBy}}</td>
      
              <td>
                <ng-container *ngIf="doc.tags">
                  <div class="tagsAl" *ngFor="let key of objectKeys(doc.tags)">{{ key }}, {{ doc.tags[key] }}</div>
                </ng-container>
              </td>
      
              <td class="action-cell">
                <button mat-icon-button class="action-btn" [matMenuTriggerFor]="actionMenu">
                  <span class="action-dots">⋮</span>
                </button>
      
                <mat-menu #actionMenu="matMenu" class="custom-mat-menu">
                  <button mat-menu-item (click)="viewDocument(doc)">View</button>
                  <button mat-menu-item (click)="documentDelete(doc)">Delete</button>
                </mat-menu>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class=" row main stepitem" *ngIf="isMergeEnable && selectedMergeDocuments?.length >=2">
        <div class="col-sm-12">
          <div class="btnbox">
            <button type="reset" class="btn btn-default btncancel" (click)="onMergeCancel()">Cancel</button>
            <button type="submit" class="btn btn-default btnsave savecls" (click)="mergeDoc()">Merge</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ngx-spinner  size="medium" type="ball-clip-rotate"></ngx-spinner>
</div>

<div class="modal" *ngIf='showConfirm' style="display:block;" tabindex="-1">
  <div class="modal-dialog" style="width: 400px; height:300px">
      <div class="modal-content">
              <button type="button" class="btn-close remBtn" data-bs-dismiss="modal" (click)="showConfirm = false;" aria-label="Close"></button>
          <div class="modal-body">
              <div class="alertpara"><p class="alertparatxt">Alert</p></div>
          </div>
          <div class="alertext remText">
            Are you sure you want to remove <br> access for {{this.gro?.name}}?
          </div>
          <div class="alertbutton botPad">
            <button class="btn btn-default alertbtn alertbtnno" data-bs-dismiss="modal"
                    (click)="showConfirm = false;" >No</button>&nbsp;&nbsp;&nbsp;            
            <button class="btn btn-default alertbtn alertbtnyes" data-bs-dismiss="modal"
                    aria-label="Close" (click)="deleMem()">Yes</button>
           </div>
          </div>
      </div>
</div>

<!-- <div class="modal" *ngIf='delConfirm' style="display:block;" tabindex="-1">
  <div class="modal-dialog" style="width: 400px; height:300px">
      <div class="modal-content">
              <button type="button" class="btn-close remBtn" data-bs-dismiss="modal" (click)="delConfirm = false;" aria-label="Close"></button>
          <div class="modal-body"> <div class="alertpara"><p class="alertparatxt">Confirmation</p></div></div>
          <div class="alertext remText2">
            Are you sure you want to delete <br> <b>{{docname?.name}}</b> document?
          </div>
          <div class="alertbutton botPad">
            <button class="btn btn-default alertbtn alertbtnno" data-bs-dismiss="modal"
                  (click)="delConfirm = false;" aria-label="Close">No</button>&nbsp;&nbsp;&nbsp;            
            <button class="btn btn-default alertbtn alertbtnyes" data-bs-dismiss="modal"
                  aria-label="Close" (click)="delDoc(docname)">Yes</button>
           </div>
          </div>
      </div>
</div> -->


<!-- Alert dialog for Clients-->
<div *ngIf='successModel' class="modal" id="successModal" tabindex="-1" aria-labelledby="successModalLabel" aria-hidden="true" style="display:block; margin-top:50px">
  <div class="modal-dialog">
      <div class="modal-content">
          <div class="modal-body">
            <div class="iconclose" (click)="noResp('no');">X</div>
              <div class="alertpara">
                <p class="alertparatxt">Alert</p>
              </div>
              <div class="alertext">
                <p class="dataText">Data will not be saved.</p> 
                <p class="dataText">Do you want to proceed ?</p>
              </div>
              <div class="alertbutton">
                <button class="btn btn-default alertbtn alertbtnno" (click)="noResp('no')">No</button>
                <button class="btn btn-default alertbtn alertbtnyes" (click)="successResp('yes');toggleType()">Yes</button>
              </div>
          </div>
      </div>
  </div>
</div>

<div *ngIf='keyModel' class="modal" id="successModal" tabindex="-1" aria-labelledby="successModalLabel" aria-hidden="true" style="display:block; margin-top:50px">
  <div class="modal-dialog">
      <div class="modal-content">
          <div class="modal-body">
            <div class="iconclose" (click)="nokeyResp('no');">X</div>
              <div class="alertpara">
                <p class="alertparatxt">Alert</p>
              </div>
              <div class="alertext">
                <p class="dataText">Data will not be saved.</p> 
                <p class="dataText">Do you want to proceed ?</p>
              </div>
              <div class="alertbutton">
                <button class="btn btn-default alertbtn alertbtnno" (click)="nokeyResp('no')">No</button>
                <button class="btn btn-default alertbtn alertbtnyes" (click)="keyResp('yes')">Yes</button>
              </div>
          </div>
      </div>
  </div>
</div>

<!-- Calendar event popup, triggered from Timeline -->
<app-viewevent
  *ngIf="showEventPopup"
  [eventData]="selectedEventData"
  [eventType]="selectedEventType"
  [popoverTop]="popoverTop"
  [popoverLeft]="popoverLeft"
  (closed)="closeEventPopup()"
  (eventDeleted)="onTimelineEventDeleted()">
</app-viewevent>